import React from 'react';

export const TabButton = ({ icon: Icon, label, isActive, onClick }) => (
    <button
        onClick={onClick}
        className={`flex items-center px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 whitespace-nowrap ${isActive
            ? "bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm"
            : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800"
            }`}
    >
        <Icon className="w-4 h-4 mr-1" />
        {label}
    </button>
);
